import {forwardRef, useCallback, useEffect, useRef, useState} from "react";
import {generateUUID2, getImagePathWithTheme, getImagePathWithThemeSvg, isDarkMode} from "../../utils";
import {getPropertyById, updateProperty} from "../../../model";
import {
    ARRAY_PROPERTY_OPTIONS_COLOR, FROM_TAG,
    getDefaultTagBackgroundColor,
    getPropertySelectOptionBackgroundColor, MAX_Z_INDEX
} from "../../Const";
import {Popover, Select, Tag, message } from "antd";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import { t } from "i18next";
import "./TableView.css"
import {getTagBackgroundIndex, setTagBackgroundIndexAdd} from "@/LocalStroageUtils";

const CustomPropertySelect = forwardRef((props:{propertyId:any,selectOptions:any,onSelectChanged:any,from?:any,randomId?:any},ref)=>{

    const [property,setProperty] = useState(null);
    const [arraySelectOptions,setArraySelectOptions] = useState([]);
    const [mapIsSelectHovered,setMapIsSelectHovered] = useState<any>({});
    const [arraySelectInfo,setArraySelectInfo] = useState([]);
    const mArraySelectInfo = useRef<any>(null);
    const [isOpenSelect,setIsOpenSelect] = useState(false);
    const [isSelectHovered,setIsSelectHovered] = useState(false);
    const [isFocus,setIsFocus] = useState(false);

    const mProperty = useRef<any>(null);
    const mIsOpenSelect = useRef(false);
    const mIsFocus = useRef(false);
    const mThisUUID = useRef(generateUUID2());

    useEffect(()=>{
        getPropertyById(props.propertyId).then(res=>{
            mProperty.current = res;
            setProperty(res);
            setArraySelectOptions(res.items);
        })
        setArraySelectInfo(props.selectOptions);
    },[props.propertyId,props.selectOptions])

    useEffect(() => {
        mIsOpenSelect.current = isOpenSelect;
    }, [isOpenSelect]);

    useEffect(() => {

    }, []);

    useEffect(()=>{
        window.refreshList['refresh_property_select_open_'+mThisUUID.current] = refreshPropertySelectOpen;
        return ()=>{
            delete window.refreshList['refresh_property_select_open_'+mThisUUID.current];
        }
    })

    useEffect(() => {
        mArraySelectInfo.current = arraySelectInfo;
    }, [arraySelectInfo]);

    const refreshPropertySelectOpen = (szUUID:any)=>{
        if (mThisUUID != szUUID){
            setIsOpenSelect(false);
        }
    }

    /**
     * 更新属性...
     * @param newTag
     */
    const onUpdateProperty = (option:any,isDelete=false)=>{
        const arrayNewSelect = [...arraySelectOptions]
        const nIndex = arrayNewSelect.findIndex(p=>p.id == option.id);
        if (nIndex != -1){
            if (isDelete){
                arrayNewSelect.splice(nIndex,1);
            }else{
                arrayNewSelect.splice(nIndex,1,option);
            }

        }
        setArraySelectOptions(arrayNewSelect);
        //更新到数据库.
        getPropertyById(mProperty.current?.id).then(res=>{
            res.items = arrayNewSelect;
            updateProperty(res).then(rrr=>{
                setProperty(res);
                mProperty.current = res;

                if (window['refresh_tableview_']){
                    window['refresh_tableview_']();
                }
                window.globalRefreshList('refresh_gridview_');//刷新网格视图
            });
        })
    }

    /**
     * 更多菜单
     */
    const renderMore = (option:any) => {
        return <div className={'flex-col'} onMouseDown={(e) => {
            e.stopPropagation();
        }} onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
        }}>
            <input id={`txt-table-view-select-${option.id}`} className={'input-border input-border-focus'}
                   autoFocus={true}
                   defaultValue={option.text}  onBlur={(e) => {
                if (e.currentTarget.value) {
                    //判断是否已经有这个名称了。。。
                    const hasExist = arraySelectOptions.some(p => p.text.toLowerCase() == e.currentTarget.value.toLowerCase() && p.id != option.id);
                    if (hasExist) {
                        message.error(t('DataExists'));
                    } else {
                        const newTag = {...option, text: e.currentTarget.value}
                        onUpdateProperty(newTag);
                    }
                }
            }} onInput={(e) => {
                // setInputValue(e.currentTarget.value);
            }} onKeyDown={(e) => {
                if (e.key == KEYS.ENTER) {
                    const txt = document.getElementById(`txt-table-view-select-${option.id}`);
                    txt?.blur();

                    const newMap = {...mapIsSelectHovered};
                    newMap['popup-more-'+option.id] = false;
                    setMapIsSelectHovered(newMap);
                }
            }}/>
            <div className={'flex-row-vertical-center cursor-pointer hovered-gray-radius-3'}
                 style={{height: '32px', margin: '8px -12px 0px -12px'}} onClick={(e) => {
                window.showMessageBox(t("Delete option"), t("SureToDeleteOption"), t("Cancel"), t("Delete"), null, () => {
                    //删除
                    const arrayNewSelect = [...arraySelectInfo];
                    let nIndex = arrayNewSelect.findIndex(p => p.id == option.id);
                    if (nIndex != -1) {
                        arrayNewSelect.splice(nIndex, 1);
                        setArraySelectInfo(arrayNewSelect);
                    }
                    //从集合中删除
                    //保存到数据库
                    onUpdateProperty(option,true);
                })
            }}>
                <img className={'img-16 ml-20'} src={getImagePathWithThemeSvg('option_delete')}/>
                <span className={'ml-8'}>{t('Delete option')}</span>
            </div>
            <div className={'line mt-12'} style={{margin: '8px -12px'}}></div>
            <div className={'mt-2'} style={{
                display: 'grid',
                padding: '0 8px',
                gap: '12px 0',
                gridTemplateColumns: 'repeat(4,auto)',
                justifyContent: 'space-between'
            }}>
                {
                    ARRAY_PROPERTY_OPTIONS_COLOR.map(p => {
                        return <div className={'cursor-pointer'} style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '8px',
                            background: `${isDarkMode()?p.useDarkColor:p.color}`
                        }}  onMouseDown={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setTimeout(()=>{
                                const newTag = {...option, backgroundColor: p.usedColor};
                                onUpdateProperty(newTag);
                            },100)
                        }}>
                        </div>
                    })
                }
            </div>

        </div>
    }

    const tagRender: any = useCallback((props,from,onSelectChanged) => {
        const ttttaaaagggggg = mProperty.current?.items?.find(p => p.id == props.value);
        return (
            <Tag
                closable={(mIsFocus.current || mIsOpenSelect.current)?true:false}
                onClose={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    const arrayNewSelect:any = [...mArraySelectInfo.current];
                    const nIndex = arrayNewSelect.findIndex(p => p.id == props.value);
                    arrayNewSelect.splice(nIndex, 1);
                    setArraySelectInfo(arrayNewSelect);
                    if (from == FROM_TAG){
                        onSelectChanged(arrayNewSelect);
                    }
                }}
                className={'tableview-tag default-font-size flex-row-vertical-center'}
                style={{
                    backgroundColor: getPropertySelectOptionBackgroundColor(ttttaaaagggggg?.backgroundColor),
                    marginLeft: '0px',
                    marginRight:'4px',
                    color:'var(--text-color)'
                }}
            >
                <span>{ttttaaaagggggg?.text}</span>
                {
                    // (mIsFocus.current || mIsOpenSelect.current) &&
                    // <img className={'img-8 cursor-pointer'} src={getImagePathWithTheme('')} onClick={(e)=>{
                    //     e.stopPropagation();
                    //     e.preventDefault();
                    //     const arrayNewSelect:any = [...mArraySelectInfo.current];
                    //     const nIndex = arrayNewSelect.findIndex(p => p.id == props.value);
                    //     arrayNewSelect.splice(nIndex, 1);
                    //     setArraySelectInfo(arrayNewSelect);
                    // }}/>
                }

            </Tag>
        );
    }, []);

    const getSelectText = () => {
        const arrayTxt = [];
        for (let i = 0; i < arraySelectInfo?.length; i++) {
            arrayTxt.push(arraySelectInfo[i].id);
        }
        return arrayTxt;
    }

    //是多选吗？
    const isMultipSelect = () => {
        return property?.type == 'multiSelect'
    }

    /**
     * 选择下拉选项的时候
     * @param p
     */
    const onSelectOption = async (p)=>{
        mIsFocus.current = true;
        if (arraySelectInfo.some(pp => pp?.id == p.id)) {
            //已经有了，返回.
            return;
        }

        if (p.isNew) {
            //保存到这个自定义属性下的select 中去...
            const newArraySelectOptions:any = [...mProperty.current.items];
            delete p.isNew;
            newArraySelectOptions.push(p);
            setArraySelectOptions(newArraySelectOptions);

            // mProperty.current.items.push(p);
            const newProperty = {...mProperty.current};
            newProperty.items.push(p);
            setProperty(newProperty);

            await updateProperty(mProperty.current);

            let nTagBackgroundIndex = getTagBackgroundIndex();
            setTagBackgroundIndexAdd(nTagBackgroundIndex);
        }

        let arrayNewSelect: any = [...arraySelectInfo];
        if (!isMultipSelect()) {
            arrayNewSelect = [];
            setIsOpenSelect(false);
        }
        arrayNewSelect.push(p);
        setArraySelectInfo(arrayNewSelect);

        //触发一下更新.
        if (props.onSelectChanged){
            props.onSelectChanged(arrayNewSelect)
        }
    }

    const getSomeClass = ()=>{
        if (props.from == FROM_TAG){
            if (isOpenSelect){
                return 'aaaaa-ant-select-multiple';
            }
            return 'normal-ant-select-selector';
        }
        return '';
    }

    return <Select
            autoFocus={false}
            mode={"tags"}
            open={isOpenSelect}
            suffixIcon={null}
            placeholder={t("Empty")}
            tagRender={(ppppppppppprops)=>tagRender(ppppppppppprops,props.from,props.onSelectChanged)}
            value={getSelectText()}
            options={arraySelectOptions}
            variant={'borderless'}
            onFocus={(e)=>{
                mIsFocus.current = true;
                setIsFocus(true);

                if (props.from == FROM_TAG) {
                    window.globalRefreshList('refresh_property_select_open_',mThisUUID.current)
                    setIsOpenSelect(true);
                }
            }}
            onBlur={(e)=>{
                mIsFocus.current = false;
                setIsFocus(false);

                if (props.from == FROM_TAG){
                    setTimeout(()=>{
                        if (document.activeElement?.tagName == 'INPUT'){

                        }else{
                            setIsOpenSelect(false);
                        }
                    },100)

                }
            }}
            onDropdownVisibleChange={(e)=>{
                if (props.from == FROM_TAG){

                }else{
                    setIsOpenSelect(e);
                    if (!e){
                        if (props.onSelectChanged){
                            props.onSelectChanged(arraySelectInfo)
                        }
                    }
                }

            }}
            onMouseDown={(e)=>{
                e.stopPropagation();
            }}
            onMouseEnter={(e)=>{
                setIsSelectHovered(true);
            }}
            onMouseLeave={(e)=>{
                setIsSelectHovered(false);
            }}
            onKeyDown={(e)=>{
                if (e.key == KEYS.ENTER){
                    if (arraySelectOptions.length == 1 && arraySelectOptions[0].isNew){
                        onSelectOption(arraySelectOptions[0]);
                        if (e.target?.tagName == 'INPUT'){
                            e.target.blur();
                            setTimeout(()=>{
                                e.target.focus();
                            },100)
                        }
                    }
                }
            }}
            className={'fix-gab-select-custom-height-center select-focus-background select-property-info-placeholder-fix ' + (getSomeClass())}
            style={{width:props.from == FROM_TAG?'calc(100% - 40px)':'100%',
                background:((isOpenSelect || isSelectHovered))?'var(--tableview-select-background-color)':'transparent',
                borderRadius:isOpenSelect?'8px 8px 0 0':'8px',
                position:(props.from == FROM_TAG)?'absolute':'inherit',
                zIndex:`${MAX_Z_INDEX}`}}
            onSearch={(e) => {
                const szValue = e.toLowerCase();
                const arrayNewOptions: any = [];
                for (let i = 0; i < mProperty.current?.items?.length; i++) {
                    const item = mProperty.current?.items[i];
                    if (item.text.toLowerCase().includes(szValue)) {
                        arrayNewOptions.push(item);
                    }
                }
                if (arrayNewOptions.length == 0) {
                    let nTagBackgroundIndex = getTagBackgroundIndex();
                    //创建一个新的----
                    arrayNewOptions.push({
                        id: generateUUID2(),
                        text: e,
                        isNew: true,
                        sort: 0,
                        backgroundColor:ARRAY_PROPERTY_OPTIONS_COLOR[nTagBackgroundIndex].usedColor
                    })
                }
                setArraySelectOptions(arrayNewOptions);
            }}
            // placeholder={t('SearchForAnOption')}
            dropdownClassName={'tableview-dropdown-select'}
            dropdownStyle={{maxHeight:`${document.body.clientHeight*0.5}px`,overflow:'auto',zIndex:'999999'}}
            dropdownRender={(menus) => {
                return <div className={'flex-col'} onClick={(e)=>{
                    e.stopPropagation();
                }}>
                    {
                        arraySelectOptions?.length == 0?<div className={'flex-row-vertical-center'} style={{color:'var(--text-color-bab8b8)',height:'38px',paddingLeft:'8px'}}>{t('No options')}</div>:
                        arraySelectOptions?.map(p => {
                            return <div data-id={p.id}
                                        className={'flex-row-vertical-center cursor-pointer hovered-gray-radius-3'}
                                        style={{padding: '4px 8px',}} onClick={async (e) => {
                                e.stopPropagation();
                                onSelectOption(p);
                            }} onMouseEnter={(e) => {
                                const newMap = {...mapIsSelectHovered};
                                const arrayKeys = Object.keys(newMap);
                                arrayKeys.forEach(pp=>{
                                    newMap[pp] = false;
                                })
                                newMap[p.id] = true;
                                setMapIsSelectHovered(newMap);
                            }} onMouseLeave={(e) => {
                                const newMap = {...mapIsSelectHovered};
                                const arrayKeys = Object.keys(newMap);
                                arrayKeys.forEach(pp=>{
                                    newMap[pp] = false;
                                })
                                setMapIsSelectHovered(newMap);
                            }}>
                                <div>
                                    {
                                        p.isNew &&
                                        <label
                                            style={{marginRight: '8px'}}>{t('Create')}</label>
                                    }
                                    <label className={'tableview-tag cursor-pointer'}
                                           style={{
                                               background: getPropertySelectOptionBackgroundColor(p.backgroundColor),
                                               display: 'inline-block',
                                               borderRadius: '4px',
                                           }}>{p.text}</label>
                                </div>
                                {
                                    <Popover trigger={['click']} content={renderMore(p)}
                                             arrow={false}
                                             open={mapIsSelectHovered['popup-more-'+p.id]}
                                             overlayStyle={{zIndex:`${MAX_Z_INDEX}`}}
                                             overlayInnerStyle={{width: '200px',}}
                                             placement={'rightTop'}
                                             onOpenChange={(e)=>{
                                                 const newMap = {...mapIsSelectHovered};
                                                 newMap['popup-more-'+p.id] = e;
                                                 setMapIsSelectHovered(newMap);
                                             }}
                                             afterOpenChange={(e) => {
                                                 if (e) {
                                                     setTimeout(() => {
                                                         const txt = document.getElementById(`txt-table-view-select-${p.id}`);
                                                         if (txt) {
                                                             txt.focus();
                                                         }
                                                     }, 20)
                                                 }
                                             }}>
                                        <div className={'flex-center'} style={{
                                            width: '22px',
                                            height: '22px',
                                            marginLeft: 'auto'
                                        }} onMouseDown={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                        }} onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                        }}>
                                            {
                                                !p.isNew && mapIsSelectHovered[p.id] &&
                                                <img style={{}}
                                                     className={'img-12 cursor-pointer mr-10'}
                                                     src={getImagePathWithTheme('note_card_h_more')}
                                                />
                                            }

                                        </div>

                                    </Popover>
                                }

                            </div>
                        })
                    }
                </div>
            }}
        />
})

export default CustomPropertySelect;